<template>
  <div>
    <a @click="editPlanTreatment"
       v-if="hasRightToEditPlan"
       class="tdclickable">
      {{ object.message }}
    </a>
    <span v-else>{{ object.message }}</span>
  </div>
</template>

<script>
import { mapState } from "vuex"

export default {
  name: "PatientsDatatableTDTreatmentMessage",
  props: {
    object: {
      type: Object
    }
  },
  computed: {
    ...mapState({
      rights: state => state.auth.rights,
    }),
    hasRightToEditPlan() {
      return this.rights.includes('edit_plan_treatment')
          || this.rights.includes('edit_plan_treatment_limited')
    },
  },
  methods: {
    editPlanTreatment() {
      if(!this.hasRightToEditPlan) {
        return
      }
      this.$router.push({
        name: 'TreatmentPlanFullCard',
        params: {
          patientId: this.object.client_id,
          planId: this.object.planning_id,
        }
      })
    }
  }
}
</script>
